import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Home, Calendar, TrendingUp, User, Crown, Shield } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Navigation = ({ active }) => {
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    checkAdminStatus();
  }, []);

  const checkAdminStatus = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return;
      
      const response = await axios.get(`${API}/subscription/status`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setIsAdmin(response.data.is_admin);
    } catch (error) {
      console.error('Error checking admin status:', error);
    }
  };

  const navItems = [
    { id: 'home', label: 'Home', icon: Home, path: '/' },
    { id: 'calendar', label: 'Calendar', icon: Calendar, path: '/calendar' },
    { id: 'analytics', label: 'Analytics', icon: TrendingUp, path: '/analytics' },
    { id: 'profile', label: 'Profile', icon: User, path: '/profile' },
  ];

  return (
    <nav className="nav-bar" data-testid="navigation">
      <div className="max-w-6xl mx-auto px-2 sm:px-4">
        <div className="flex justify-around md:justify-center md:space-x-4 lg:space-x-6 items-center overflow-x-auto">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = active === item.id;
            return (
              <button
                key={item.id}
                data-testid={`nav-${item.id}`}
                onClick={() => navigate(item.path)}
                className="flex flex-col md:flex-row items-center gap-0.5 md:gap-2 py-2 px-2 sm:px-3 rounded-lg transition flex-shrink-0"
                style={{
                  color: isActive ? '#A2DAD3' : '#666',
                  backgroundColor: isActive ? '#f0f9f8' : 'transparent',
                }}
              >
                <Icon size={18} className="sm:w-5 sm:h-5" />
                <span className="text-[10px] sm:text-xs md:text-sm font-medium">{item.label}</span>
              </button>
            );
          })}
          
          {/* Subscription Link */}
          <button
            data-testid="nav-subscription"
            onClick={() => navigate('/subscription')}
            className="flex flex-col md:flex-row items-center gap-0.5 md:gap-2 py-2 px-2 sm:px-3 rounded-lg transition flex-shrink-0"
            style={{
              color: active === 'subscription' ? '#A2DAD3' : '#666',
              backgroundColor: active === 'subscription' ? '#f0f9f8' : 'transparent',
            }}
          >
            <Crown size={18} className="sm:w-5 sm:h-5" />
            <span className="text-[10px] sm:text-xs md:text-sm font-medium">Plan</span>
          </button>

          {/* Admin Link - Only show for admins */}
          {isAdmin && (
            <button
              data-testid="nav-admin"
              onClick={() => navigate('/admin')}
              className="flex flex-col md:flex-row items-center gap-0.5 md:gap-2 py-2 px-2 sm:px-3 rounded-lg transition flex-shrink-0"
              style={{
                color: active === 'admin' ? '#A2DAD3' : '#9333ea',
                backgroundColor: active === 'admin' ? '#f0f9f8' : 'transparent',
              }}
            >
              <Shield size={18} className="sm:w-5 sm:h-5" />
              <span className="text-[10px] sm:text-xs md:text-sm font-medium">Admin</span>
            </button>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
